import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';

export const toggleFeedbackDialog = createAction<boolean>(
  `${storeName}/toggleFeedbackDialog`,
);
